import { useLazyQuery as c } from "@apollo/client";
import l from "../../../apostle-lib/deserializes/hooks/useMakeApostleMintConfig.js";
import g from "../../../bounty-lib/deserializes/hooks/useMakeBountyConfig.js";
import { frontendConfigSchema as d } from "../../deserializes/yup/config.js";
import y from "../../graphql/getFrontendConfig.js";
import { i18nNamespace as C } from "../../../temp-lib/constants/i18n.js";
import { DEFAULT_LOCALE as k } from "../../../temp-lib/constants/locale.js";
import { hyphenLocale as h } from "../../../temp-lib/util/i18n/helper/locale.js";
import * as n from "ramda";
import { useState as L, useCallback as M } from "react";
import { useTranslation as A } from "react-i18next";
const R = () => {
  const [r, { loading: s }] = c(y), { i18n: e } = A(), [m, u] = L(null), { makeApostleMintConfig: a } = l(), { makeBountyConfig: i } = g(), f = M(async () => {
    const p = await r(), t = n.pathOr(
      {},
      ["data", "getSystemConfig", 0],
      p
    );
    try {
      const o = d.cast(t);
      return n.isNil(o) ? null : (o.apostleMintConfig = a(t), o.bounty = i(t), u(o), n.isNotEmpty(o.i18nLookup) && e.addResourceBundle(
        h(k),
        C.Backend,
        {
          ...o.i18nLookup
        },
        !0,
        !0
      ), o);
    } catch (o) {
      console.error(o);
    }
    return null;
  }, [e, a, i, r]);
  return {
    data: m,
    loading: s,
    fetch: f
  };
};
export {
  R as default
};
//# sourceMappingURL=useGetFrontendConfig.js.map
